// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__cVc8w"};